import { useDataSubmit } from 'Simple/Data'

export function useOnSubmit(props) {
  let submit = useDataSubmit({
    context: 'charge',
    viewPath: props.viewPath,
  })

  return function onSubmit(value) {
    submit({ type: 'copy', location_ids: value })
    if (typeof props.closePopover === 'function') props.closePopover()
  }
}
